module.exports = __webpack_public_path__ + "static/media/proj1_img10.5a597fda.jpg";